import Stepper from "../../components/Stepper";
import { FormControl, TextField } from "@material-ui/core";
import React, { Fragment, useEffect, useState } from "react";
import { saveAs } from "file-saver";
import ErrorPopUp from "../../components/ErrorPopUp";
import { useSelector } from "react-redux";
import { useTouristDocumentTitle } from "../../lib/useTouristDocumentTitle";

const queryString = require("query-string");

const PaymentReceipt = (props) => {
	const {
		t,
		getPaymentData,
		paymentDataAfterPayment,
		getPDF,
		pdf,
		receiveEmail,
		emailHasBeenSent,
		payloadAfterLogIn,
		activeStep,
		errorGetPaymentData,
	} = props;

	const [emailText, setEmailText] = useState("");
	const [error, setError] = useState(false);
	const [flagForEmail, setFlagForEmail] = useState(false);
	const [openErrorPopUp, setOpenErrorPopUp] = useState(false);
	const [openReceiptPopUp, setOpenReceiptPopUp] = useState(false);
	const [clickedSavePdf, setClickedSavePdf] = useState(false);
	const [clickedEmailPdf, setClickedEmailPdf] = useState(false);
	const [clickedPrintPdf, setClickedPrintPdf] = useState(false);

	const { isTourist } = useSelector(
		(state) => state.BalanceReducer.payloadAfterLogIn,
	);

	useTouristDocumentTitle();

	useEffect(() => {
		const parsed = queryString.parse(window.location.search);
		if (
			window.location.href.indexOf("payment") > -1 &&
			Object.keys(parsed).length !== 0 &&
			Object.keys(payloadAfterLogIn).length !== 0
		) {
			getPaymentData(parsed);
		}
	}, [payloadAfterLogIn]);

	useEffect(() => {
		if (
			paymentDataAfterPayment.success === false ||
			errorGetPaymentData ||
			paymentDataAfterPayment.code === 1
		) {
			setOpenErrorPopUp(true);
			setOpenReceiptPopUp(false);
		} else {
			setOpenReceiptPopUp(true);
		}
	}, [paymentDataAfterPayment]);

	const handleEmail = (e) => {
		setEmailText(e.target.value);
	};
	function handleFile(pdf) {
		const byteCharacters = window.atob(pdf.pdf);
		const byteNumbers = new Array(byteCharacters.length);
		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}
		const byteArray = new Uint8Array(byteNumbers);
		return new Blob([byteArray], { type: "application/pdf;base64" });
	}

	const openPdf = (pdf) => {
		window.open(URL.createObjectURL(handleFile(pdf)));
	};

	const savePdf = () => {
		saveAs(handleFile(pdf), "invoice.pdf");
	};

	const printPDF = () => {
		if (Object.keys(pdf).length !== 0) {
			openPdf(pdf);
		} else {
			const parsed = queryString.parse(window.location.search);
			if (paymentDataAfterPayment.success === true) {
				getPDF(paymentDataAfterPayment, parsed);
			}
		}
	};

	const downloadPdf = (e) => {
		if (Object.keys(pdf).length !== 0) {
			savePdf(pdf, Math.random());
		} else {
			const parsed = queryString.parse(window.location.search);
			if (paymentDataAfterPayment.success === true) {
				getPDF(paymentDataAfterPayment, parsed);
			}
		}
	};

	useEffect(() => {
		if (Object.keys(paymentDataAfterPayment).length !== 0) {
			if (clickedSavePdf) {
				saveAs(handleFile(pdf), "invoice.pdf");
				setClickedSavePdf(false);
			} else if (clickedPrintPdf) {
				openPdf(pdf);
				setClickedPrintPdf(false);
			} else if (clickedEmailPdf) {
				sendEmailReceipt();
				setClickedEmailPdf(false);
			}
		}
	}, [paymentDataAfterPayment, pdf]);

	useEffect(() => {
		if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(emailText)) {
			setError(false);
		} else if (emailText.length === 0) {
			setError(false);
		} else {
			setError(true);
		}
	}, [emailText]);

	const sendEmailReceipt = (e) => {
		if (emailText.length !== 0 && !error) {
			receiveEmail(paymentDataAfterPayment, emailText);
		}
	};

	useEffect(() => {
		if (emailHasBeenSent) {
			setFlagForEmail(true);
		} else {
			setFlagForEmail(false);
		}
	}, [emailHasBeenSent]);

	function maskify(card) {
		let hideNum = [];
		for (let i = 0; i < card?.length; i++) {
			if (i < card.length - 4 && i > card.length - 11) {
				hideNum.push("X");
			} else {
				hideNum.push(card[i]);
			}
		}
		return hideNum.join("");
	}

	let emailMessage = null;
	if (flagForEmail) {
		emailMessage = (
			<div
				className="visitLink sendEmailSuccess"
				style={{ marginTop: "10px", textAlign: "right" }}
			>
				<b>{t("emailSuccess")}</b>
			</div>
		);
	} else if (!emailHasBeenSent && flagForEmail) {
		emailMessage = (
			<div
				className="visitLink sendEmailFailed"
				style={{ marginTop: "10px", textAlign: "right", color: "red" }}
			>
				<b>{t("emailFailed")}</b>
			</div>
		);
	} else {
		emailMessage = <div></div>;
	}

	return (
		<Fragment>
			{openReceiptPopUp ? (
				<div className="hover_bkgr_terms_container_prof popup_open">
					{openReceiptPopUp &&
						paymentDataAfterPayment.success === true &&
						Object.keys(paymentDataAfterPayment).length !== 0 && (
							<div className="simple-popup">
								<div className="simple-popup-content simple-popup-content-confirm">
									<span className="modalTitle">
										{isTourist ? t("billPayment") : t("paymentAndRenewal")}
									</span>
									<Stepper t={t} activeStep={activeStep} />
									<div
										id="paymentPopupContentContainer"
										className="paymentContent thirdStepContent stepsContainer"
										style={{ display: "block;" }}
									>
										<div
											id="paymentPopupContentSuccessMessage"
											className="paymentWithIcon"
										>
											<span className="paymentWithIconTitle">
												{t("successPaymentMessage")}
											</span>
										</div>

										{paymentDataAfterPayment.success === true &&
										Object.keys(paymentDataAfterPayment).length !== 0 ? (
											<div id="content">
												<div className="paymentDetails noPadding">
													<div className="paymentDetailsCol">
														<span id="paypalAccountLabel">
															{t("creditCardNumber")}
														</span>
														<strong className="paypalAccount">
															{paymentDataAfterPayment?.card?.pan
																? maskify(paymentDataAfterPayment?.card?.pan)
																: paymentDataAfterPayment?.maskedPAN}
														</strong>
													</div>
													<div className="paymentDetailsCol">
														<span id="amountLabel">{t("receiptAmount")}</span>
														<strong className="amount">
															{paymentDataAfterPayment.amount}
														</strong>
														€
													</div>
													<div className="paymentDetailsCol">
														<span id="transactionIdLabel">
															{t("merchantRefNum")}
														</span>
														<strong className="paypalOrderId">
															{paymentDataAfterPayment.merchantRef}
														</strong>
													</div>
													<div className="paymentDetailsCol">
														<span id="transactionIdLabel">{t("authCode")}</span>
														<strong className="paypalOrderId">
															{paymentDataAfterPayment.authCode}
														</strong>
													</div>
													<div className="paymentDetailsCol">
														<span id="dueDateLabel">{t("dateTime")}</span>
														<strong className="paymentDate">
															{paymentDataAfterPayment.transactionDate}
														</strong>
													</div>
												</div>
												<div
													id="paymentPopupContentContainer"
													className="paymentContent thirdStepContent stepsContainer"
													style={{ display: isTourist ? "none" : "block;" }}
												>
													<div
														id="paymentPopupContentSuccessMessage"
														className="paymentWithIcon"
													>
														<div className="paymentContentTitle textb">
															{t("emailInputTitle")}
														</div>
														<FormControl
															fullWidth
															sx={{ m: 1 }}
															variant="filled"
														>
															<TextField
																error={error}
																helperText={error ? t("emailError") : ""}
																id={
																	error
																		? "filled-error-helper-text"
																		: "filled-adornment-amount"
																}
																type="text"
																label="Email"
																value={emailText}
																onChange={handleEmail}
																variant="filled"
															/>
														</FormControl>
													</div>
													{emailMessage}
												</div>
											</div>
										) : null}

										<div
											className="billActions row"
											style={{ display: isTourist ? "none" : "block" }}
										>
											<a
												id="printPdf"
												className="billAction col-md-3"
												onClick={(e) => {
													setClickedPrintPdf(true);
													printPDF(e);
												}}
											>
												<i className="symmetry-icon-printer"></i>
												{t("print")}
											</a>
											<a
												id="savePdf"
												className="billAction actionPrint col-md-4"
												onClick={(e) => {
													setClickedSavePdf(true);
													downloadPdf(e);
												}}
											>
												<i className="symmetry-icon-document-download"></i>
												{t("savePdf")}
											</a>
											<a
												id="emailPdf"
												className={
													error
														? "billAction actionMail col-md-5 button disabled"
														: "billAction actionMail" + " col-md-5"
												}
												onClick={(e) => {
													setClickedEmailPdf(true);
													if (emailText?.length === 0) {
														setError(true);
													} else if (
														/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
															emailText,
														)
													) {
														setError(false);
														sendEmailReceipt(e);
													}
												}}
											>
												<i className="symmetry-icon-email"></i>
												{t("sendEmail")}
											</a>
										</div>
										<div
											className="close"
											onClick={() => {
												setOpenReceiptPopUp(false);
												window.location.href = "/";
											}}
										></div>
									</div>
								</div>
							</div>
						)}
				</div>
			) : null}
			{openErrorPopUp || errorGetPaymentData ? (
				<ErrorPopUp
					errorGetPaymentData={errorGetPaymentData}
					setOpenErrorPopUp={setOpenErrorPopUp}
					openErrorPopUp={openErrorPopUp}
					t={t}
					text={
						errorGetPaymentData
							? t("creditPaymentNotCompleted")
							: t("paymentError")
					}
					paymentDataAfterPayment={paymentDataAfterPayment}
				/>
			) : null}
		</Fragment>
	);
};

export default PaymentReceipt;
